import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

export default {
  namespaced: true,
  state () {
    return {
      format: null,
      pdftemplate: null,
      logofile: {
        file: null,
        name: null
      },
      xsltfile: {
        file: null,
        name: null
      }
    }
  },
  actions,
  mutations,
  getters
}
